module.exports = __webpack_public_path__ + "static/media/login_FlexiSzlahuKulcs.4297eafc.svg";